import React from 'react'

export const Page404 = (props) => (
  <h1>
    404 Page not found...
  </h1>
)